<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">센터관리</span>
            <span class="txt">센터의 이름, 주소, 전화번호 등 센터의 기본정보를 설정합니다.</span>
        </div>

        <div class="com-table-top">
            <div class="logo-area">
                <div class="logo-box">
                    <span class="logo">
                        <img :src="data.logoUrl" alt="" />
                    </span>
                </div>
                <div class="info-box">
                    <span class="location">{{ data.centerName }}</span>
                    <span class="address">
                        {{ data.address }} {{ data.addressDetail }} /
                        {{ `${data.telNo1 || ''}-${data.telNo2 || ''}-${data.telNo3 || ''}` }}
                    </span>
                    <span v-if="data.centerType == 'M'" class="type">본사</span>
                    <span v-else class="type">지점</span>
                </div>
            </div>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-tab">
                <span v-for="(item, index) in submenus" :key="index">
                    <router-link :class="{ on: $route.name == item.name }" :to="{ ...item, params: { centerId } }">
                        {{ item.label }}
                    </router-link>
                </span>
            </div>

            <table class="com-table left" style="margin-top: 30px">
                <colgroup>
                    <col style="width: 60px" />
                    <col style="width: 500px" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>기간</th>
                        <td>
                            <div class="com-calendar-wrap">
                                <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                                <div class="com-dash"><span class="dash">~</span></div>
                                <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                                <select-form
                                    style="margin-left: 10px"
                                    :select-data="['오늘', '어제', '이번달', '지날달', '3개월', '6개월', '12개월']"
                                    :select-value="[
                                        'today',
                                        'yesterday',
                                        'thisMonth',
                                        'prevMonth',
                                        'threeMonth',
                                        'sixMonth',
                                        'year',
                                    ]"
                                    :selected-value="period"
                                    @update:set="(val) => periodc(val)"
                                ></select-form>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>결제 상태</th>
                        <td>
                            <div class="com-calendar-wrap">
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchDivision == 0 ? 'active' : ''}`"
                                    @click="onSearchDivision(0)"
                                >
                                    전체
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchDivision == 1 ? 'active' : ''}`"
                                    @click="onSearchDivision(1)"
                                >
                                    승인
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchDivision == 2 ? 'active' : ''}`"
                                    @click="onSearchDivision(2)"
                                >
                                    진행중
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchDivision == 3 ? 'active' : ''}`"
                                    @click="onSearchDivision(3)"
                                >
                                    거절
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchDivision == 4 ? 'active' : ''}`"
                                    @click="onSearchDivision(4)"
                                >
                                    취소
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr style='display: none'>
                        <th>결제 수단</th>
                        <td>
                            <div class="com-calendar-wrap">
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 0 ? 'active' : ''}`"
                                    @click="onSearchMethod(0)"
                                >
                                    전체
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 1 ? 'active' : ''}`"
                                    @click="onSearchMethod(1)"
                                >
                                    카드
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 2 ? 'active' : ''}`"
                                    @click="onSearchMethod(2)"
                                >
                                    현금
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 3 ? 'active' : ''}`"
                                    @click="onSearchMethod(3)"
                                >
                                    계좌이체
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 4 ? 'active' : ''}`"
                                    @click="onSearchMethod(4)"
                                >
                                    기타
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="bottom-btn" style="margin-top: 20px">
                <button class="com-btn" @click="onSearch">검색</button>
                <button class="com-btn border-button general-button big" @click="onConditionInit">조건 초기화</button>
            </div>

            <div class="com-table-content">
                <div class="table-top-container">
                    <div class="left-box">
                        <p class="table-top-title"><strong>결제내역</strong></p>
                    </div>
                    <div class="right-box">
                        <span class="table-top-count">
                            총
                            <span class="blue">{{ paymentList.length }}</span>
                            개
                        </span>
                    </div>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 200px" />
                        <col style="width: 170px" />
                        <col />
                        <col style="width: 150px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <div class="com-check">
                                    <input
                                        id="check-all"
                                        v-model="selectedAll"
                                        name="check-all"
                                        type="checkbox"
                                        @click="checkedAll"
                                    />
                                    <label for="check-all"></label>
                                </div>
                            </th>
                            <th>
                                <button
                                    :class="
                                        paymentListSortColumn === 'cs_cre_dt'
                                            ? paymentListSortType === 'DESC'
                                                ? ''
                                                : 'degree'
                                            : ''
                                    "
                                    @click="onClickSendDt"
                                >
                                    결제일시
                                </button>
                            </th>
                            <th>충전금액</th>
                            <th>결제금액</th>
                            <th>결제수단</th>
                            <th>결제 상태</th>
                            <th>비고</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(t, i) in resultCodeToStatus" :key="i">
                            <td>
                                <div class="com-check">
                                    <input
                                        :id="i"
                                        v-model="selected"
                                        :value="i"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label :for="i"></label>
                                </div>
                            </td>
                            <td>{{ t.AuthDate }}</td>
                            <td>{{ formatNumber(t.chargedpoint) + '원' }}</td>
                            <td>{{ formatNumber(t.amt) + '원' }}</td>
                            <td>{{ toKoreanCard(t.PayMethod) }}</td>
                            <td>{{ t.progress }}</td>
                            <td>{{ t.memo }}</td>
                        </tr>
                        <tr v-if="resultCodeToStatus.length === 0">
                            <td colspan="100">등록된 내역이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="com-btn-area table-bottom-func">
                    <div class="left-box">
                        <button class="com-btn excel" @click="excelDownload()">엑셀 다운로드</button>
                    </div>
                    <div class="right-box">
                        <select-form
                            :select-data="[...sortTypeList]"
                            :select-value="[...sortTypeValueList]"
                            :selected-value="pagingInfo.limit"
                            class="float-right"
                            @update:set="changeLimit"
                        ></select-form>
                    </div>
                </div>
                <b-pagination
                    v-model="pagingInfo.page"
                    :per-page="pagingInfo.limit"
                    :total-rows="pagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation($event)"
                ></b-pagination>
            </div>
        </template>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { pagingInfo } from '@/assets/js/common';
import { Utils } from '@/assets/js/utils';
import XLSX from 'xlsx';
import paymentApi from '@/assets/js/paymentApi';

export default {
    name: 'SettingCenterPaymentList',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
    },
    props: ['centerId'],
    computed: {
      resultCodeToStatus() {
        return this.paymentList.map((item) => {
          let status;
          console.log(item);
          if (item.PayMethod == 'Admin') {
            // 관리자 포인트인 경우
            const adminDate = new Date(item.authdate).toLocaleString('ko-KR');

            return {
              ...item,
              PayMethod: '관리자',
              AuthDate: adminDate,
              progress: '승인', // 관리자 포인트 충전으로 명시
            };
          } else {
            console.log(item.progress);
            switch (item.progress) {
              case 'rejected':
                status = '거절';
                break;
              case 'cancel':
                status = '취소';
                break;
              case 'inProgress':
                status = '진행중';
                break;
              case 'approved':
                status = '승인';
                break;
              default:
                status = '';
            }

            // AuthDate를 Date 객체로 직접 변환
            const date = new Date(item.authdate);

            // Date 객체를 한국 시간으로 변환
            const authDate = date.toLocaleString('ko-KR', { timeZone: 'Asia/Seoul' });

            return { ...item, AuthDate: authDate, progress: status };
          }
        });
      },
    },
    watch: {},
    created() {},
    mounted() {
        this.init();
        this.onSearchList();
    },
    data() {
        return {
            data: {},
            submenus: [
                { name: 'SettingCenterEdit', label: '기본정보' },
                { name: 'SettingCenterProgram', label: '프로그램 가입내역' },
                { name: 'SettingCenterHoliday', label: '휴일설정' },
                { name: 'SettingCenterAccount', label: '정산설정' },
                { name: 'SettingCenterPaymentList', label: '결제내역' },
                { name: 'SettingCenterPaymentMethod', label: '결제수단' },
                { name: 'SettingCenterFitpay', label: '핏페이' }, // TESTING ON PROD
                // { name: 'SettingCenterLecture', label: 'Cross lesson settings' },
            ],

            isLoading: false,
            paymentList: [],
            pagingInfo: { ...pagingInfo },
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            paymentListSortColumn: 'cs_cre_dt',
            paymentListSortType: 'DESC',

            selectedAll: false,
            selected: [],

            startDate: this.initStartDate(),
            endDate: this.initEndDate(),
            period: 'thisMonth', // 등록일 조회
            searchStr: '',
            searchDivision: 0,
            searchMethod: 0,
        };
    },
    methods: {
        // 초기화
        async init() {
            console.log(this.centerId);

            this.isLoading = true;
            if (!this.centerId) return;
            api.get(`/admin/api/center/${this.centerId}`)
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data;
                    let telNo = [];
                    if (this.data.telNo.length === 8) {
                        //전화번호가 8글자일경우 적용됨(21.03.17)
                        telNo = this.data.telNo.match(/(\d{4})(\d{4})/);
                        telNo = ['', ...telNo];
                    } else if (this.data.telNo.indexOf('02') === 0) {
                        telNo = (this.data.telNo || '').match(/(\d{2})(\d{3,4})(\d{4})/);
                    } else if (this.data.telNo.length === 10) {
                        telNo = (this.data.telNo || '').match(/(\d{3})(\d{3})(\d{4})/);
                    } else {
                        telNo = (this.data.telNo || '').match(/(\d{3})(\d{4,4})(\d{4})/);
                    }

                    if (telNo) {
                        this.data.telNo1 = telNo[1];
                        this.data.telNo2 = telNo[2];
                        this.data.telNo3 = telNo[3];
                        this.data.telNo = telNo;
                    }

                    this.data.faxNo = (this.data.faxNo || '').match(/(\d{2,3})(\d{3,4})(\d{4})/);
                    if (this.data.faxNo) {
                        this.data.faxNo1 = this.data.faxNo[1];
                        this.data.faxNo2 = this.data.faxNo[2];
                        this.data.faxNo3 = this.data.faxNo[3];
                    }
                })
                .catch((res) => {
                    this.isLoading = false;
                    this.data = {};
                    if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
            this.isLoading = true;

            this.isLoading = false;
        },

        // 페지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },

        // 이용권명 컬럼 클릭시
        onClickSendDt() {
            this.paymentListSortColumn = 'cs_cre_dt';
            if (this.paymentListSortType === '' || this.paymentListSortType === 'DESC') {
                this.paymentListSortType = 'ASC';
            } else {
                this.paymentListSortType = 'DESC';
            }
            this.onSearchList();
        },

        // Excel Download
        async excelDownload() {
          const excelDownloadArray = [];
          console.log(this.selected)
          this.resultCodeToStatus.forEach((item, index) => {
            if (this.selected.includes(index)) {
              const temp = {};
              temp['결제일시'] = item.AuthDate;
              temp['충전금액'] = this.formatNumber(item.chargedpoint) + '원';
              temp['결제금액'] = this.formatNumber(item.amt) + '원';
              temp['결제수단'] = this.toKoreanCard(item.PayMethod);
              temp['결제상태'] = item.progress;
              temp['비고'] = item.memo;

              excelDownloadArray.push(temp);
            }
          });

          const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);
          const wb = XLSX.utils.book_new();

          XLSX.utils.book_append_sheet(wb, dataWS, 'paymentList');
          XLSX.writeFile(wb, 'paymentList.xlsx');
        },

      // 한 페지에 표시되는 줄 수 변경
      changeLimit(val) {
        this.pagingInfo.limit = val;
        this.onSearchList();
      },

      checkedAll() {
        // 전체 선택 기능
        this.selected = [];
        if (!this.selectedAll) {
          for (const i in this.paymentList) {
            this.selected.push(parseInt(i));
          }
        }
      },
      // 검색 종료일
      initEndDate() {
        const endDate = moment().endOf('month').format('YYYY-MM-DD');
        return endDate;
      },

      // 검색 시작일
      initStartDate() {
        const startDate = moment().startOf('month').format('YYYY-MM-DD');
        return startDate;
      },

      periodc(newValue) {
        this.period = newValue;
        if (newValue === 'thisMonth') {
          this.startDate = moment().startOf('month').format('YYYY-MM-DD');
          this.endDate = moment().endOf('month').format('YYYY-MM-DD');
        } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
        },

        async onSearchList() {
            try {
                this.isLoading = true;
                const progress = this.statusToApiFormat(this.searchDivision);
                const response = await paymentApi.post(`/admin/api/payment/history/${this.centerId}`, {
                  startDate: this.startDate,
                  endDate: this.endDate,
                  page: this.pagingInfo.page,
                  skip: this.pagingInfo.limit,
                  searchKeyword: this.searchStr,
                  ...(progress && { progress }),
                });

                this.paymentList = response.data.list;
                this.totalItems = response.data.count;
                this.pagingInfo.totalItems = response.data.count;
                console.log('paymentList', this.paymentList);
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        statusToApiFormat(status) {
            switch (status) {
              case 1:
                return 'approved';
              case 3:
                return 'rejected';
              case 2:
                return 'inProgress';
              case 4:
                return 'cancel';
              case 0:
              default:
                return null;
            }
        },

        //쉼표 찍기
        formatNumber(value) {
            return new Intl.NumberFormat().format(value);
        },
        toKoreanCard(value) {
            return value === 'CARD' ? '카드' : value;
        },
        onSearchDivision(type) {
            this.searchDivision = type;
        },

        onSearchMethod(type) {
            this.searchMethod = type;
        },

        // 검색어 입력 처리
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
        },

        onSearch() {
            this.pagingInfo.page = 1;
            this.onSearchList();
        },

        onConditionInit() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.period = 'thisMonth';
            this.searchStr = '';
            this.searchDivision = 0;
            this.searchMethod = 0;
        },
    },
};
</script>
<style lang="scss"></style>
